import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'

class LegislationForm extends React.Component {

    constructor(props) {
        super(props);
        this.initialState = {
            isFormShow: true,
            type: '',
            title: '',
        }
        this.state = this.initialState;
    }

    handleShowForm = () => {
        this.setState(this.initialState);
        this.setState({
            isFormShow: !this.state.isFormShow
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.handleSubmit(this.state.type, this.state.title);
        this.setState(this.initialState);
    }

    render() {
        const { isFormShow, type, title } = this.state;
        const textButtom = isFormShow ? 'Ocultar Formulario' : 'Mostrar Formulario';
        const iconButton = isFormShow ? faAngleUp : faAngleDown;

        const isInvalid = type === '' || title === '';

        return (
            <div>
                <div className="accordion" id="accordionOfferForm">
                    <div className="nav justify-content-end">
                        <button onClick={this.handleShowForm} className="btn btn-dark btn-sm" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                            {textButtom}
                            <FontAwesomeIcon className="ml-2" icon={iconButton} />
                        </button>
                    </div>
                    <div id="offerFormCollapse" className="collapse show" data-parent="#accordionOfferForm">
                        <div className="pt-2 pl-3 pr-3">
                            <form onSubmit={this.handleSubmit}>
                                <div className="">
                                    <div className="row">
                                        <div className="col col-12 col-md-4 p-2">
                                            <select value={type} onChange={this.handleChange} name="type" className="form-control">
                                                <option value="">Seleccione una categoría ...</option>
                                                <option value="General">General</option>
                                                <option value="Nivel inicial">Nivel inicial</option>
                                                <option value="Nivel primario">Nivel primario</option>
                                                <option value="Nivel secundario">Nivel secundario</option>
                                                <option value="Nivel terciario">Nivel terciario</option>
                                                <option value="Paritaria">Paritaria</option>
                                                <option value="Otras modalidades">Otras modalidades</option>
                                            </select>
                                        </div>

                                        <div className="col col-12 col-md-8 p-2">
                                            <input className="form-control" value={title} type="text" onChange={this.handleChange} name="title" placeholder="Título" />
                                        </div>
                                        <div className="col-12 nav justify-content-end p-2">
                                            <button disabled={isInvalid} type="submit" className="btn btn-success">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default LegislationForm;